import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ApiRequest from "../Common/restservice";
function Token() {
  const { token } = useParams();
  const navigate = useNavigate();
  useEffect(() => {
    GetMyProfile();
  }, []);
  const GetMyProfile = async (e) => {
    let res = await ApiRequest("MyProfile.asp", "GET", null, {
      Authorization: token,
    });
    if (res.status === "error") {
      if (res.message === "Token Expired") {
        localStorage.clear();
        return navigate("/login");
      }
    }
    localStorage.setItem("token", token);
    localStorage.setItem("username", res.username);
    localStorage.setItem("usertype", res.usertype);
    localStorage.setItem("usertypecategory", res.usertypecategory);
    navigate("/", { replace: true });
  };
  return <div></div>;
}

export default Token;
